import React from "react";
import clsx from "clsx";

import { IconComponent, ImageComponent } from "@app/core/";
import IconDefault from "@assets/icons/link.svg";
import IcnChevronRight from "@assets/icons/chevron-right-sharp.svg";
import { OutBannerDTO } from "@app/bf-api";
import { getOptimizedImageUrl } from "@app/util/image-optimization";
import IconHot from "@assets/icons/labels/hot.svg";

import { BannerVariant } from "../banner.component";
import styles from "./banner-2025.module.scss";

export type Banner2025Props = {
  banner?: OutBannerDTO;
  bannerLink?: string;
  buttonText: string;
  showAlternativeBanner?: boolean;
  variant: BannerVariant;
};

export const Banner2025 = (props: Banner2025Props) => {
  const { banner, bannerLink, variant, showAlternativeBanner } = props;

  return (
    <a rel="sponsored" href={bannerLink} target="_blank" className={clsx(styles.banner, styles[variant])}>
      <div className={clsx(styles.holder, showAlternativeBanner && styles.rowReverse)}>
        <div className={styles.image}>
          <div className={styles.imageWrapper}>
            <ImageComponent
              alt={banner?.bannerImage?.alt || ""}
              src={
                getOptimizedImageUrl({
                  url: banner?.bannerImage?.url,
                  height: 280
                }) || ""
              }
              title={banner?.bannerImage?.title || ""}
              errorImage={IconDefault}
              isBlocking
              forceImageTag
            />
          </div>
        </div>

        <div className={styles.body}>
          <div className={styles.content}>
            <div className={styles.header}>
              {banner?.name && <h2 className={styles.title}>{banner.name}</h2>}
              <div className={styles.label}>
                <IconComponent icon={IconHot} fillColor="white" size="10px" />
                {banner?.label}
              </div>
            </div>
            <span className={styles.description}>{banner?.description}</span>
          </div>

          <div className={styles.button}>
            <IconComponent icon={IcnChevronRight} fillColor="white" size="16px" />
          </div>
        </div>
      </div>
    </a>
  );
};
